import { createStyles, makeStyles, Theme } from '@material-ui/core';

const storiesStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      display: 'flex',
      alignItems: 'center',
      width: 400
    },
    input: {
      marginLeft: theme.spacing(1),
      flex: 1
    },
    iconButton: {
      padding: 10
    },
    divider: {
      height: 28,
      margin: 4
    }
  })
);

export const editStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      position: 'sticky',
      top: theme.spacing(6),
      background: '#fff',
      zIndex: 2
    },
    actionButtonRow: {
      display: 'flex',
      gap: theme.spacing(0.5)
    },
    iconButton: {
      padding: theme.spacing(1),
      borderRadius: 6
    }
  })
);

export const taskStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      width: '100%',
      backgroundColor: theme.palette.background.paper
    }
  })
);

export default storiesStyles;
